import React, { createContext, useContext, useEffect, useState } from 'react';
import api, { unwrap } from '../utils/api';

const Ctx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('hazmoona_admin_token');
    if (!token) { setReady(true); return; }
    api.get('/auth/my-account')
      .then(r => setAdmin(unwrap(r)))
      .catch(() => localStorage.removeItem('hazmoona_admin_token'))
      .finally(() => setReady(true));
  }, []);

  async function signIn(email, password) {
    const r = await api.post('/auth/sign-in', { email, password });
    const body = unwrap(r);
    localStorage.setItem('hazmoona_admin_token', body.token);
    setAdmin(body.admin);
    return body.admin;
  }

  function signOut() {
    localStorage.removeItem('hazmoona_admin_token');
    setAdmin(null);
  }

  return <Ctx.Provider value={{ admin, ready, signIn, signOut }}>{children}</Ctx.Provider>;
}

export const useAdminAuth = () => useContext(Ctx);
